import React from "react"
import { graphql } from "gatsby"
import styled from 'util/style'

import Layout from 'components/Layout'
import SEO from 'components/SEO'

const BannerImage = styled.img`
  display: block;
  margin: 0 auto 40px auto;
  max-height: 300px;

  @media only screen and (max-width: 600px) {
    max-height: 200px;
  }
`

const Title = styled.h1`
  margin: 0 auto 10px auto;
  text-align: center;

  @media only screen and (max-width: 600px) {
    font-size: 1.6em;
  }
`

const Author = styled.h2`
  text-align: center;
  font-weight: light;
  font-size: 26px;
  margin-bottom: 40px;
  color: #7cc1b7;
`

const Content = styled.div`
  max-width: 65%;
  margin: 0 auto;
  text-align: justify;
  line-height: 2em;

  @media only screen and (max-width: 600px) {
    font-size: 0.8em;
    max-width: 90%;
  }

  a {
    color: #7cc1b7;
    font-weight: bold;
    text-decoration: none;
    padding-bottom: 1px;
    border-bottom: 1px solid transparent;
    transition: border-bottom-color 0.1s ease-in-out;

    &:hover {
      border-bottom-color: #7cc1b7;
    }
  }

  .block-img {
    width: 140%;
    margin-left: -20%;

    @media (max-width: 640px) {
      max-width: 90%;
      margin-left: 0;
    }
  }
`

const Post = ({ data: { prismicBlogPost } }) => {
  const { data } = prismicBlogPost
  return (
    <Layout>
      <SEO title={data.title.text} />

        {data.banner_image.localFile &&
            <BannerImage src={data.banner_image.localFile.url} alt={data.title.text} />
        }

        <Title>{data.title.text}</Title>
        <Author>By {data.authors}</Author>

        <Content dangerouslySetInnerHTML={{ __html: data.content.html }} />

    </Layout>
  )
}

export default Post

export const pageQuery = graphql`
  query PostBySlug($uid: String!) {
    prismicBlogPost(uid: { eq: $uid }) {
      uid
      data {
        authors,
        title {
          text
        }
        content {
          html
        }
        banner_image {
            localFile {
                url
            }
        }
      }
    }
  }
`